import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BorderouService {
    private basePath = environment.interop.basePath;
    public downloadPdfUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.downloadPDF;
    public downloadCsvUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.downloadCSV;
    private generateBorderouUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.generateBorderou;

    constructor(private http: HttpClient) { }

    generateBorderou(nrDays: number, documentIds: number[], blockDocs: boolean) {
        return this.http.post(this.generateBorderouUrl, { number_of_days: nrDays, document_ids: documentIds, block_documents: blockDocs });
    }
}
